<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="700"
    >
        <v-card>
            <v-card-title style="margin-bottom:15px;">
                {{ 'Classificação e orçamento do pedido com IA' }}
            </v-card-title>
            <v-card-text v-if="loading" class="center-align" style="display:flex; flex-direction:column; align-items:center;">
                <v-progress-circular
                    indeterminate
                    color="grey"
                    :size="60"
                ></v-progress-circular>
                <p class="question" style="margin-top:20px;">Aguardando a análise da IA. Isso pode levar alguns segundos...</p>
            </v-card-text>
            <v-card-text v-else-if="error">
                <p class="question">Não foi possível analisar o pedido.</p>
                <p class="center-text red--text">{{error}}</p>
            </v-card-text>
            <v-card-text v-else-if="result">
                <template v-if="classification">
                    <p class="question">Classificação sugerida:</p>
                    <p><span class="question highlight">{{classification.classificacao}}</span></p>
                    <p class="center-text" v-if="classification.confianca != null">Confiança: {{Math.round(classification.confianca * 100)}}%</p>
                    <p class="center-text" v-if="classification.alternativa">Alternativa: {{classification.alternativa}}</p>
                    <p class="center-text" v-if="classification.pedido_origem">Pedido de origem: {{classification.pedido_origem}}</p>
                    <v-card class="cardSpace">
                        <v-card-title class="subtitle">Justificativa</v-card-title>
                        <v-card-text class="text">{{classification.justificativa}}</v-card-text>
                    </v-card>
                    <v-card class="cardSpace" v-if="classification.avisos && classification.avisos.length">
                        <v-card-title class="subtitle">Avisos</v-card-title>
                        <v-card-text class="text">
                            <ul>
                                <li v-for="(aviso, i) in classification.avisos" :key="i">{{aviso}}</li>
                            </ul>
                        </v-card-text>
                    </v-card>
                </template>
                <v-card class="cardSpace" v-if="estimate">
                    <v-card-title class="subtitle">Orçamento: {{formatHours(estimate.estimativa_horas)}} (confiança {{estimate.confianca}})</v-card-title>
                    <v-card-text class="text">
                        <p>Faixa total: {{formatRange(estimate.faixa_horas)}}</p>
                        <ul>
                            <li v-for="(faixa, etapa) in estimate.etapas" :key="etapa">{{stageLabels[etapa] || etapa}}: {{formatRange(faixa)}}</li>
                        </ul>
                        <p style="margin-top:10px;" v-if="estimate.premissas"><b>Premissas:</b> {{estimate.premissas}}</p>
                        <p v-if="estimate.conferir"><b>Conferir:</b> {{estimate.conferir}}</p>
                        <p v-if="estimate.qtd_horas_lancadas != null">Já lançado no pedido: {{formatHours(estimate.qtd_horas_lancadas)}}</p>
                        <p v-if="!estimate.pode_lancar_sem_revisao" class="orange--text">Revisar o orçamento antes de lançar.</p>
                        <v-checkbox v-if="classification" v-model="applyHours" color="black" hide-details :label="`Preencher Quantidade Horas com ${formatHours(estimate.estimativa_horas)}`"></v-checkbox>
                        <p v-if="saveError" class="red--text" style="margin-top:10px;">Não foi possível gravar as horas orçadas: {{saveError}}</p>
                    </v-card-text>
                </v-card>
                <v-card class="cardSpace" v-if="!classification">
                    <v-card-title class="subtitle red--text">A IA não retornou uma classificação</v-card-title>
                    <v-card-text class="text" style="white-space:pre-line;">{{result.texto}}</v-card-text>
                </v-card>
            </v-card-text>
            <v-card-actions style="justify-content:flex-end;">
                <v-btn v-if="error" @click="analyze()">
                    Tentar novamente
                    <v-icon class="btnSpace">mdi-refresh</v-icon>
                </v-btn>
                <v-btn v-if="classification && !loading" :loading="saving" color="black" style="color: white;" @click="apply()">
                    Aplicar
                    <v-icon class="btnSpace">mdi-check</v-icon>
                </v-btn>
                <v-btn :disabled="loading || saving" @click="closeModal()">Cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import classificarPedido from '../../../src/app/classificacaoIA/classificarPedido'
import updateAiHours from '../../../src/app/classificacaoIA/updateAiHours'

export default {
    name: 'classificationIAModal',
    props: ['dialog', 'order', 'serviceId'],
    data(){
        return {
            loading : false,
            saving : false,
            error : '',
            saveError : '',
            result : null,
            applyHours : true,
            stageLabels : {
                analise: 'Análise',
                desenvolvimento: 'Desenvolvimento',
                testes: 'Testes',
                patch_teste: 'Patch antecipado para teste',
                patch_producao: 'Patch personalizado para produção'
            }
        }
    },
    computed: {
        classification(){
            return this.result && this.result.classificacao
        },
        estimate(){
            return this.result && this.result.orcamento
        }
    },
    methods : {
        closeModal(){
            this.$emit('close')
        },
        async apply(){
            const hours = this.estimate && this.applyHours ? this.estimate.estimativa_horas : null
            // As horas orçadas pela IA são gravadas na hora em SERVICO_ATM.QTD_HORAS_IA; o resto só ao salvar o pedido
            if(hours != null){
                this.saving = true
                this.saveError = ''
                try {
                    await updateAiHours({ serviceId: this.serviceId, hours })
                } catch (error) {
                    this.saveError = (error.response && error.response.data && error.response.data.error) || error.message
                    return
                } finally {
                    this.saving = false
                }
            }
            this.$emit('save', { id: this.classification.servico_classificacao_id, hours })
        },
        formatHours(hours){
            return `${String(hours).replace('.', ',')} h`
        },
        formatRange(range){
            if(!range) return ''
            return range.min == range.max
                ? this.formatHours(range.min)
                : `${String(range.min).replace('.', ',')} a ${this.formatHours(range.max)}`
        },
        async analyze(){
            this.loading = true
            this.error = ''
            this.result = null
            try {
                const response = await classificarPedido({ pedido: this.order })
                this.result = response.data
            } catch (error) {
                this.error = (error.response && error.response.data && error.response.data.error) || error.message
            } finally {
                this.loading = false
            }
        }
    },
    async created(){
        await this.analyze()
    }
}
</script>
<style scoped>

.question{
    font: 'Baloo 2';
    text-align: center;
    font-size: 22px;
    width:100%;
}
.highlight{
    font-weight:bold;
}
.center-align{
    justify-content: center;
    margin-top:15px;
}
.center-text{
    text-align: center;
}
.cardSpace{
    margin-top:10px;
    padding:10px;
}
.subtitle{
    font-size: 18px;
}
.text{
    font-size: 16px;
    text-align: justify;
}
.btnSpace{
    margin-left:5px;
}
</style>
